import React from "react";

import AntDTag, { TagProps as AntDTagProps } from "antd/es/tag";

export interface TagProps extends AntDTagProps {
  // this prop is added by the ListWithOverflowItem, and we
  // avoid slipping it into the AntDTag props
  invisible?: boolean;
}

const Tag = ({ invisible, ...props }: TagProps) => {
  return <AntDTag {...props} />;
};

export default Tag;
